export { default as DesktopFAQs } from './DesktopFAQs';
export { default as MobileFAQs } from './MobileFAQs';
